/* eslint-disable react/no-array-index-key */
import React, { useState, useMemo } from 'react';
import { Image } from 'antd';
import NotFoundImage from './not-found.png';
import { isImageFile, getFileExtension, FILE_RECT_ICONS } from '../../../../../../../utils/fileTypeIcons';
import './styles.css';

const ProductCarousel = ({ images, product }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const isAttachment = product.type === 'attachment';
  const isImage = isImageFile(product.fileType);
  const fileExtension = getFileExtension(product.fileName);
  const fileIcon = FILE_RECT_ICONS[fileExtension];
  const isDocumentAttachment = isAttachment && !isImage && fileIcon;

  return (
    <div className="clients-v2-collection-product-carousel">
      {!images?.length && (
        <div
          className={isDocumentAttachment ? 'clients-v2-collection-product-carousel--file-icon' : 'clients-v2-collection-product-carousel--image'}
          onClick={isDocumentAttachment ? () => window.open(product.url, '_blank') : undefined}
        >
          <Image
            src={isDocumentAttachment ? fileIcon : NotFoundImage}
            width={isDocumentAttachment ? 150 : 300}
            height={isDocumentAttachment ? 150 : 300}
            preview={false}
          />
        </div>
      )}

      {!!images?.length && (
        <>
          <div className="clients-v2-collection-product-carousel--selector">
            {images.map((image, index) => (
              <div
                key={index}
                className={isDocumentAttachment ? 'clients-v2-collection-product-carousel--thumbnail-icon' : undefined}
                onClick={() => setSelectedIndex(index)}
              >
                <Image
                  src={isDocumentAttachment ? fileIcon : image}
                  width={isDocumentAttachment ? 30 : 50}
                  height={isDocumentAttachment ? 30 : 50}
                  preview={false}
                  fallback={NotFoundImage}
                />
              </div>
            ))}
          </div>

          <div
            className={isDocumentAttachment ? 'clients-v2-collection-product-carousel--file-icon' : 'clients-v2-collection-product-carousel--image'}
            onClick={isDocumentAttachment ? () => window.open(product.url, '_blank') : undefined}
          >
            <Image
              src={isDocumentAttachment ? fileIcon : images[selectedIndex]}
              width={isDocumentAttachment ? 150 : 300}
              height={isDocumentAttachment ? 150 : 300}
              fallback={NotFoundImage}
              preview={isDocumentAttachment ? false : true}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ProductCarousel;
